import utils from '../utils/utils'
import _ from 'lodash'
import Axios from 'axios'

const createCoreStore = (objectName, remoteResource, manualPluralName) => {
    let pluralName = typeof manualPluralName == 'undefined' ? objectName + 's' : manualPluralName;
    let capObjectName = objectName.charAt(0).toUpperCase() + objectName.slice(1);
    let capPluralName = pluralName.charAt(0).toUpperCase() + pluralName.slice(1);
    return {
        _remoteResource: remoteResource,
        _names: {
            objectName,
            pluralName,
            capObjectName,
            capPluralName
        },
        namespaced: true,
        state: {
                [pluralName]: [],
            },
        getters: {
            [pluralName]: (state) => {
                return state[pluralName];
            },
            [objectName]:
                (state) => (id) => {
                    let objs = state[pluralName].filter(item => item.id == id);
                    return objs.length != 0 ? objs[0] : null;
                }
        }
        ,
        mutations: {
            [`add${capObjectName}`](state, payload) {
                let payloadTarget = payload[objectName];
                state[pluralName].push(payloadTarget);
            },
            [`addAll${capPluralName}`](state, payload) {
                let payloadTarget = payload[pluralName];
                state[pluralName].push(... payloadTarget);
            },
            [`clear${capPluralName}`](state) {
                state[pluralName] = [];
            },
            [`remove${capPluralName}`](state, filterFunction) {
                state[pluralName] = state[pluralName].filter(entry => !filterFunction(entry))
            }
        }
        ,
        actions: {
            [`refresh${capPluralName}`]({commit}) {
                commit(`clear${capPluralName}`);
                return Axios.get(remoteResource + "?size=500000")
                    .then(res => commit(`addAll${capPluralName}`, {[pluralName]: res.data }))
            },
            [`save${capObjectName}`]({commit, dispatch}, payload) {
                return Axios[payload.id != null ? "put": "post"](remoteResource +  (payload.id != null ? "/" + payload.id : ""),  payload)
                    .then(() => dispatch(`refresh${capPluralName}`));
            },
            [`delete${capObjectName}`]({commit, dispatch}, payload) {
                return Axios.delete(`${remoteResource}/${payload.id}`)
                    .then(() => dispatch(`refresh${capPluralName}`));
            }
        }
    }
}

const queryStore = function(store) {
    store.state.pagination = {
        actualPageItems: 0,
        actualPage: 0,
        pageSize: 20,
        totalCount: 0
    };
    store.query = {};
    store.mutations[`set${store._names.capObjectName}Pagination`] = function(state, pagination) {
        state.pagination = pagination
        state.pagination.pages = Math.floor(pagination.totalItems / pagination.pageSize) + 1;
    };
    store.mutations[`setPage`] = function(state, page) {
        state.pagination.actualPage = page;
    }
    store.mutations[`setSize`] = function(state, size) {
        state.pagination.pageSize = size;
    },
    store.getters[`${store._names.objectName}Pagination`] = (state) => {
        return state.pagination;
    };
    store.actions[`fetch${store._names.capPluralName}`] = function({},{page = 0, size = 5000, query = { parameters: {} }, sort}) {
        let targetUrl = `${store._remoteResource}?size=${size}&page=${page}&query=${encodeURI(JSON.stringify(query))}`;
        if(sort != undefined || sort != null) {
            targetUrl += `&sortField=${sort.sortField}&sortDirection=${sort.direction}`
        }
        return Axios.get(targetUrl)
            .then(utils.parsePageResponse)
            .then(res => res.list)
    };
    store.actions[`refresh${store._names.capPluralName}Paged`] = function({commit, state}, {page, query, sort, size}) {
        commit(`clear${store._names.capPluralName}`);
        if(page != undefined) {
            commit('setPage', page);
        }
        if(size != undefined) {
            commit('setSize', size);
        }
        let targetUrl = `${store._remoteResource}?size=${state.pagination.pageSize}&page=${state.pagination.actualPage}&query=${encodeURI(JSON.stringify(query))}`;
        if((sort) && (sort?.sortField)) {
           targetUrl += `&sortField=${sort.sortField}&sortDirection=${sort.direction}`
        }
        return Axios.get(targetUrl)
            .then(utils.parsePageResponse)
            .then(res => {
                commit(`addAll${store._names.capPluralName}`, {[store._names.pluralName]: res.list});
                commit(`set${store._names.capObjectName}Pagination`, {
                    actualPage: res.meta.page,
                    pageSize: res.meta.pageSize,
                    totalItems: res.meta.count,
                    actualItems: res.list.length
                })
            })
    }
    store.actions[`delete${store._names.capObjectName}`] = function({commit, dispatch, state}, payload) {
        return Axios.delete(`${store._remoteResource}/${payload.id}`)
            .then(() => dispatch(`refresh${store._names.capPluralName}Paged`, {page: state.pagination.actualPage}));
    }
    return store;
}

const searchQueryStore = function(store) {
    store.getters.queriesByType = (state) => (type) => {
        let objs = state[store._names.pluralName].filter(item => item.object == type);
        return objs;
    }

    store.getters.queryById = (state) => (name) => {
        return state[store._names.pluralName].find(item => item.id == name) || null;
    }

    return store;
}

export default {
    createCoreStore,
    queryStore,
    searchQueryStore
}